import { z } from "zod"

export const eth = {
  deposit: z.object({}),
}
